import React from "react";
import PropTypes from "prop-types";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import DisabledPlus from "../../../../../../assets/icons/Icon - Add - Disabled.svg";

const HiddenBaseStatusRow = ({ field, index, onUnhide }) => {
  return (
    <div className="individual-workflow" id={`workflowstatusBase_${index}`}>
      <div className="individual-workflow-status hidden-base-status">
        <img src={DisabledPlus} alt="base hidden" />
        <span className="status-index"></span>
        <div className="field-container-base pl-2">{field?.Name}</div>
        <OverlayTrigger
          placement="top"
          delay={{ show: 150, hide: 150 }}
          overlay={<Tooltip id="button-tooltip">Click to unhide</Tooltip>}
        >
          <Button className={`btn-icon1 unhide-eye-icon`} onClick={() => onUnhide(field.Id, field?.IsHidden)} type="button" />
        </OverlayTrigger>
      </div>
    </div>
  );
};

HiddenBaseStatusRow.propTypes = {
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onUnhide: PropTypes.func.isRequired,
};

export default HiddenBaseStatusRow;
